/**
 * Created with JetBrains WebStorm.
 * CompanyCommercialAction: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CompanyCommercialAction_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/companyCommercialActions/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CompanyCommercialAction',["CompanyCommercialAction_Resource","StoreAppData","CompanyCommercialActionData",
        function (CompanyCommercialAction_Resource,StoreAppData,CompanyCommercialActionData)
    {
        //CompanyCommercialAction inherit of $resource

        var  CompanyCommercialAction = function (resource,company)
        {
            // Call the parent constructor
            this.id = null;
            this.isDeleted = false;
            this.company = company;
            this.date = null;
            this.type = null;
            this.status = null;
            this.creator = null;
            this.author = null;
            this.description = null;

            if (resource!==undefined && resource!=null)
            {
                if (resource.date)
                    this.date = new Date(resource.date);
                if (!this.id)
                    this.id = resource.id;
                this.isDeleted = resource.isDeleted;
                this.status = resource.status;
                this.type = resource.type;
                this.author = resource.author;
                this.creator = resource.creator;
                this.description = resource.description;


            }
            CompanyCommercialActionData.add(this);
        }
        CompanyCommercialAction.prototype.getObjectResource = function() {
            var rsSub = new CompanyCommercialAction_Resource();
            rsSub.id =  this.id;
            if (this.company)
                rsSub.companyCode = this.company.code;
            rsSub.isDeleted = this.isDeleted;
            rsSub.date = this.date;
            rsSub.status = this.status;
            rsSub.type = this.type;
            rsSub.author = this.author;
            rsSub.creator = this.creator;
            rsSub.description = this.description ;
            return rsSub;
        }

        return CompanyCommercialAction;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CompanyCommercialActionSrv',["$log","CompanyCommercialAction_Resource","CompanyCommercialAction","ServerSrv","CompanyCommercialActionData",
        function ($log,CompanyCommercialAction_Resource,CompanyCommercialAction,ServerSrv,CompanyCommercialActionData)
        {
            var  companyCommercialActionSrv = {};


            companyCommercialActionSrv.save = function(companyCommercialAction,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(companyCommercialActionSrv.saveSync, companyCommercialAction, successFunction, errorFunction);
            };
            companyCommercialActionSrv.saveSync =  function(companyCommercialAction,successFunction,errorFunction)
            {
                //$timeout (function () {

                var companyCommercialActionRes = companyCommercialAction.getObjectResource();
                companyCommercialActionRes.$save({}, //no params
                    function (data) {
                        try{
                            if (!companyCommercialAction.id)
                                companyCommercialAction.id = data.id;
                            /** @namespace data.workingPeriodsId */

                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            companyCommercialActionSrv.remove = function(companyCommercialAction,successFunction,errorFunction)
            {
                CompanyCommercialActionData.remove(companyCommercialAction);
                ServerSrv.startSavingProcess(companyCommercialActionSrv.removeSync, companyCommercialAction, successFunction, errorFunction);
            };
            companyCommercialActionSrv.removeSync = function(companyCommercialAction,successFunction,errorFunction)
            {
                var res = new CompanyCommercialAction_Resource();
                res.$remove({id:companyCommercialAction.id}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

            };
            return companyCommercialActionSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CompanyCommercialActionData',["$log", function ($log)
    {
        var  companyCommercialActionData =
        {
            indexCompanyCommercialActions : []
        };
        companyCommercialActionData.getById =  function(companyCommercialActionId)
        {
            for (var i=0;i<this.indexCompanyCommercialActions.length;i++)
                if (this.indexCompanyCommercialActions[i].id==companyCommercialActionId)
                    return this.indexCompanyCommercialActions[i];
            return null;
        }
        companyCommercialActionData.getIndexOf =  function(companyCommercialAction)
        {
            if (companyCommercialAction)
                return this.indexCompanyCommercialActions.indexOf(companyCommercialAction);
            return -1;
        }
        companyCommercialActionData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexCompanyCommercialActions.length)
                return this.indexCompanyCommercialActions[index];
            else
                return null;
        }
        companyCommercialActionData.add =  function(companyCommercialAction)
        {
            this.indexCompanyCommercialActions.push(companyCommercialAction);
            return this.indexCompanyCommercialActions.length-1;
        }
        companyCommercialActionData.clear =  function()
        {
            companyCommercialActionData.indexCompanyCommercialActions = [];
        }
        companyCommercialActionData.remove =  function(companyCommercialAction)
        {
            companyCommercialAction.isDeleted=true;
            if (companyCommercialAction.company && companyCommercialAction.company.companyCommercialActions)
            {
                var index =  companyCommercialAction.company.companyCommercialActions.indexOf(companyCommercialAction);
                if (index!=-1) {
                    companyCommercialAction.company.companyCommercialActions.splice(index, 1);
                }
            }
        }

        return companyCommercialActionData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/CompanyCommercialAction.js